import { Component, input } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormUtils } from '../../../utilities/classes/form-utils';

@Component({
  selector: 'form-error-label',
  template: `
    <div class="text-bg-danger mb-2 rounded-3 text-center">
      {{ errorMessage }}
    </div>
  `,
})
export class FormErrorLabelComponent {
  control = input.required<AbstractControl>();
  personalizedError = input<string>();

  get errorMessage() {
    const errors: ValidationErrors = this.control().errors || [];

    const message = this.personalizedError()
      ? this.personalizedError()
      : FormUtils.getTextError(errors);

    return this.control().touched && Object.keys(errors).length > 0
      ? message
      : null;
  }
}
